// Idea taken from https://redux.js.org/recipes/structuring-reducers/refactoring-reducers-example#combining-reducers-by-slice
// Basically each entity (station, terminal etc.) is structured to under one reducer. So when there will be more reducers, those
// just will be added to initialState and slide reducer.

import {LOAD_STATIONPUMPS_REQUEST, LOAD_STATIONPUMPS_SUCCESS, LOAD_STATIONPUMPS_FAILURE, STATIONS_NEW_STATION, STATIONS_EDIT_STATION, STATIONS_DELETE_STATIONS} from '../actions/actionTypes';
import {createReducer, updateObject} from './reducerUtilities';


const initialState = {
    stationPumps: {
        stationPumpsData: null,
        isLoading: false,
        hasFailed: false,
        isDeleting: false
    },
};

// Slice reducer
export const stationReducer = createReducer(initialState, {
    [LOAD_STATIONPUMPS_REQUEST] : loadStationPumpsRequest,
    [LOAD_STATIONPUMPS_SUCCESS] : loadStationPumpsSuccess,
    [LOAD_STATIONPUMPS_FAILURE] : loadStationPumpsFailure,
    [STATIONS_NEW_STATION] : addStation,
    [STATIONS_EDIT_STATION] : editStation,
    [STATIONS_DELETE_STATIONS] : deleteStation
});


// -----------------------------------------------------------------------
// LOAD STATIONS
// -----------------------------------------------------------------------

// Case reducer
function loadStationPumpsRequest(state, action) {
    return {...state, stationPumps: updateObject(
        state.stationPumps, { 
            isLoading: true 
        })};
}

// Case reducer
function loadStationPumpsSuccess(state, action) {   
    return {...state, stationPumps: updateObject(
        state.stationPumps, { 
            stationPumpsData: action.payload.stationPumps, 
            isLoading: false 
        })};
}

// Case reducer
function loadStationPumpsFailure(state, action) {
    return {...state, stationPumps: updateObject(
        state.stationPumps, { 
            stationPumpsData: [], 
            isLoading: false, 
            hasFailed: true 
        })};
}

function addStation(state, action) {
    return {...state, stationPumps: updateObject(
        state.stationPumps, { 
            stationPumpsData: [...state.stationPumps.stationPumpsData, ...action.data]
        })};    
}

function editStation(state, action) {
    // const id = action.data.id
    // const stationToChange = state.stations.stationsData.find(c => c.id === id)
    // const changedStation = { ...noteToChange, important: !noteToChange.important }
    return {...state, stations: updateObject(
        state.stations, { 
            stationsData: state.stations.stationsData.map(c => c.id === action.data.id ? action.data : c)
        })}; 
}


function deleteStation(state, action) {
    return {...state}
}



// WEBPACK FOOTER //
// ./src/reducers/stationReducer.js